var _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitsCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 793,
    height: 195,
    viewBox: "0 0 793 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 396.5,
    cy: 97.5,
    rx: 396.5,
    ry: 97.5,
    fill: "url(#paint0_linear_1151_19973)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1151_19973",
    x1: 0,
    y1: 97.5,
    x2: 793,
    y2: 97.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184A7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58B6E5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitsCircle);
export default __webpack_public_path__ + "static/media/benefits-circle.4bc88166abc8b43f40c446ac52188442.svg";
export { ForwardRef as ReactComponent };